module.exports = __webpack_public_path__ + "static/media/mode-2022.b9047c30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2022.svg
// module id = 1050
// module chunks = 2